import { useLocation } from "react-router-dom"

import HomeSmile from "@/assets/icons/HomeSmile"
import { useAuth } from "@/context/auth-context"
import { useClubId } from "@/lib/hooks/use-club-id"
import routes, { routeBuilder } from "@/lib/routes"

import PageContainer from "../page-container"
import Link from "./link"

const BottomNavigationBar = () => {
  const { isAuthenticated } = useAuth()
  const { pathname } = useLocation()

  const clubId = useClubId()

  const isHomeRoute = pathname === routes.dashboard.base

  if (!isAuthenticated || isHomeRoute) return null

  return (
    <nav
      id="navigationBar"
      className="sticky bottom-0 z-[13] border-t border-surface-200 bg-white py-0.5 sm:hidden"
    >
      <PageContainer>
        <div className="relative flex items-center justify-around gap-2">
          <Link
            href={routeBuilder(routes.dashboard.base, { clubId })}
            text="Dashboard"
            activeIcon={<HomeSmile />}
          />
        </div>
      </PageContainer>
    </nav>
  )
}

export default BottomNavigationBar
